import React from 'react'
import { Link } from 'gatsby'

export default function Breadcrumbs(props) {
    const { path, children } = props
    const segments = path?.split('/')?.slice(0, -1)
    // console.log(segments)
    return(
        <p
            className='d-flex a-center g-2'
            style={{ marginBottom: 24, fontSize: 11 }}
        >
            {segments.map((segment, i) => {
                const url = segments.slice(0, i + 1).join('/')
                const isLast = i === segments.length - 1
                // console.log(url)
                return(
                    <>
                        <Link
                            key={url}
                            to={url ? url : '/'}
                            className='hover-underline capitalize white'
                        >
                            {
                                (isLast && children) ? children :
                                segment ? segment.replaceAll('-', ' ') :
                                'home'
                            }
                        </Link>
                        {!isLast && '/'}
                    </>
                )
            })}
        </p>
    )
}
